export default [
  {
    path: '/board/barBoard',
    component: () => import('../../views/board/barBoard/Index.vue'),
    name: 'board-barBoard',
    meta: {
      auth: 0,
      backgroundClass: 'bg-dark',
      title: 'AE8实时销售表',
    },
  },
];
